module.exports = __webpack_public_path__ + "static/imagem-impressao-1c-e1563384096971-f61e0afad26d06f83d11b90bcb9979b2.jpg";